import { FC } from 'react'
import { Form, Checkbox } from 'antd-mobile'
import { useTranslation } from "react-i18next";
import css from './index.module.less'
import { Link } from 'react-router-dom'
import { useNav } from '@/hooks/useNav'
import i18n from '@/utils/i18n';

export const AgreeFormItem: FC<{
  name: string,
}> = ({ name, ...rest }) => {
  const { t } = useTranslation();
  const { genLink } = useNav()

  return (
    <Form.Item className={css.CheckboxWrap} name={name} rules={rules}  {...rest}>
      <Checkbox className={css.Checkbox}>{t('user-center.login.agreement')}
        <Link className={'no-decoration'} to={genLink('/user-agreement')}>{t('user-center.register.protocol')}</Link>
        <Link className={'no-decoration'} to={genLink('/privacy-agreement')}>{t('user-center.register.privacy')}</Link>
      </Checkbox>
    </Form.Item>
  )
}


const rules: any[] = [{ validator: (rule, value) => value ? Promise.resolve() : Promise.reject(`${i18n.t('user-center.login.rule-agree')}`) }];
